import React from 'react';
import * as S from './styles';

interface CardScoreProps {
	score?: number;
	fontSize?: string;
}

export function CardScore({ score, fontSize = '1.2rem' }: Readonly<CardScoreProps>): JSX.Element {
	return (
		<S.Container $score={score} $fontSize={fontSize}>
			<span>{score ? score : '-'}</span>
		</S.Container>
	);
}
